// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1SPWV","title":"BackImages_title__T5obN","images":"BackImages_images__2Um1L"};